import { useCallback, useRef, useEffect } from 'react';
import { isSafari } from 'react-device-detect';
import { If, Then } from 'react-if';
import { useColorMode } from '@chakra-ui/react';
import { Debugger, Footer, Greeting, Header } from '~/components';
import { useConfig } from '~/context';
import { useFormState } from '~/hooks';

import type { FlexProps } from '@chakra-ui/react';

export const Layout = (props: FlexProps): JSX.Element => {
  const { developerMode } = useConfig();
  const { colorMode } = useColorMode();
  const { setStatus, reset } = useFormState(
    useCallback(({ setStatus, reset }) => ({ setStatus, reset }), []),
  );

  useEffect(() => {
    if (colorMode === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [colorMode]);

  const containerRef = useRef<HTMLDivElement>({} as HTMLDivElement);

  async function handleReset() {
    const snapEl = document.getElementById('__snap-container');
    if (snapEl) {
      snapEl.style.scrollSnapType = 'none';
      snapEl.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setTimeout(() => {
      setStatus('form');
      reset();
      if (snapEl) {
        snapEl.style.scrollSnapType = 'y mandatory';
      }
    }, 400);
  }

  return (
    <div
      className="bg-slate-50 dark:bg-background text-slate-800 dark:text-on-background font-body-lg flex flex-col relative overflow-hidden"
      id="__hyperglass"
      ref={containerRef}
      style={{ height: isSafari ? '-webkit-fill-available' : '100vh' }}
    >
      <Header />
      <main className="flex-1 flex flex-col items-center w-full z-10" style={{ overflow: 'hidden', height: 'calc(100vh - 4rem)' }}>
        {props.children}
      </main>
      <Footer />
      <If condition={developerMode}>
        <Then>
          <Debugger />
        </Then>
      </If>
      {/* Visual Polish: Background Shader Overlay */}
      <div className="fixed inset-0 -z-10 opacity-30 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(42,157,143,0.08),transparent_70%)]"></div>
      </div>
      <Greeting />
    </div>
  );
};
